import React from 'react'
import ReactSelect from 'react-select'

const SelectField = ({
  label,
  error,
  className,
  onChange,
  value,
  options,
  isMulti
}) => {
  return (
    <label className={`flex flex-col ${className}`}>
      {label && <span className={`text-${error ? 'red-600' : 'gray-500'}`}>{label}</span>}

      <ReactSelect
        classNamePrefix='react-select'
        styles={{ control: base => ({ ...base, border: error && '2px solid red' })}}
        onChange={onChange}
        value={value}
        options={options}
        isMulti={isMulti}
      />

      {error && <span className="text-sm text-red-600 font-light">{error}</span>}
    </label>
  )
}

export default SelectField
